function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 120 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.071,
    height: 13.717,
    viewBox: "0 0 15.071 13.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bxupysim1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3211",
    style: {
      stroke: "#fcaf17",
      fill: "#de5934"
    },
    d: "M0 0h15.071v13.717H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8752"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8720",
    style: {
      clipPath: "url(#bxupysim1a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5489",
    d: "M14.737 11.267 9.072 1.286a1.555 1.555 0 0 0-2.7 0L.7 11.267a1.555 1.555 0 0 0 1.351 2.321h11.335a1.555 1.555 0 0 0 1.351-2.321z",
    transform: "translate(-.185 -.185)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#de5934",
      fill: "#de5934"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 197",
    transform: "translate(7.536 4.176)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M0 0v4.52"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 198",
    transform: "translate(7.536 10.669)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M0 0v.157"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedFlag);
export default __webpack_public_path__ + "static/media/speedFlag.baa3a3ab76b44589f6974e2f78dcb453.svg";
export { ForwardRef as ReactComponent };